import React, { useState, useEffect, useRef } from "react";

import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import SettingsIcon from "@mui/icons-material/Settings";
import InfoIcon from "@mui/icons-material/Info";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Grid from "@mui/system/Unstable_Grid";
import Container from "@mui/material/Container";
import ongData from "../scripts/formOng";
import AccordionOdd from "../../src/components/AccordionOdd";

import {
  FaInfoCircle,
  FaArrowRight,
  FaArrowLeft,
  FaMinusCircle,
} from "react-icons/fa";
import { ApiUrl } from "../config";
import { CheckmarkIcon } from "react-hot-toast";
import { Link } from "react-router-dom";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <InfoIcon />,
    2: <SettingsIcon />,
    3: <Check />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        icons[String(props.icon)]
      )}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = [
  "Informations générales",
  "à propos de l'organisation",
  "Finish",
];

const animatedComponents = makeAnimated();

const MemberInscription = () => {
  const stepperRef = useRef(null);

  const [activeStep, setActiveStep] = useState(0);
  const [oddOptions, setOddOptions] = useState([]);
  const [servicesOdd, setServicesOdd] = useState({});

  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [sexe, setSexe] = useState("");
  const [email, setEmail] = useState("");
  const [telephoneFix, setTelephoneFix] = useState("");
  const [emailOrganisation, setEmailOrganisation] = useState("");
  const [nomOrganisme, setNomOrganisme] = useState("");
  const [siteWeb, setSiteWeb] = useState("");
  const [role, setRole] = useState("");

  const [nature, setNature] = useState();
  const [secteur, setSecteur] = useState([]);
  const [service, setService] = useState([]);
  const [region, setRegion] = useState();
  const [province, setProvince] = useState();
  const [commune, setCommune] = useState();
  const [assistance, setAssistance] = useState([]);

  const natureOptions = ongData.nature;
  const assistanceOptions = ongData.assistance;
  const secteurOptions = ongData.secteur;
  const servicesOptions = ongData.service;
  const regionOptions = ongData.region;
  const provinceOptions = ongData.provinces;
  const communeOptions = ongData.commune;

  const [demande, setDemande] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    console.log("Before Mapping:", assistance);

    if (activeStep === 0) {
      setDemande({
        prenom: prenom,
        nom: nom,
        sexe: sexe,
        email: email,
        nom_organisme: nomOrganisme,
        site_web: siteWeb,
        telephoneFix: telephoneFix,
        emailOrganisation: emailOrganisation,
        assistance: assistance,
        role: role,
      });
    } else if (activeStep === 1) {
      setDemande((prevState) => ({
        ...prevState,
        nature: nature,
        region: region,
        province: province,
        commune: commune,
        services: service.map((x) => x.value),
        secteurs: secteur.map((x) => x.value),
        infos_organisation: servicesOdd,
      }));

      console.log(demande);
    }
  }, [
    activeStep,
    prenom,
    nom,
    sexe,
    email,
    telephoneFix,
    emailOrganisation,
    nomOrganisme,
    siteWeb,
    assistance,
    role,
    nature,
    region,
    province,
    commune,
    servicesOdd,
  ]);

  const handleNext = () => {
    if (activeStep === 0) {
      if (isStepOneValid) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      return;
    } else if (activeStep === 1) {
      fetch(`${ApiUrl}new/demande`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(demande),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(errorData.message || "Something went wrong");
            });
          }
          return response.json();
        })
        .then((data) => {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          console.log("Success:", data);
          setErrorMessage(""); // Clear any previous error on success
        })
        .catch((error) => {
          console.error("Error:", error.message);
          setErrorMessage(error.message); // Set the error message to display in the alert
        });

      if (stepperRef.current) {
        const stepperY =
          stepperRef.current.getBoundingClientRect().top + window.scrollY - 100;

        window.scrollTo({ top: stepperY, behavior: "smooth" });
      }
    }
  };

  const handleBack = () =>
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const handleReset = () => {
    setActiveStep(0);

    setNom("");
    setPrenom("");
    setSexe("");
    setEmail("");
    setNomOrganisme("");
    setRole("");
    setEmailOrganisation("");
    setTelephoneFix("");
    setAssistance([]);
    setSecteur([]);
    setService([]);
    setSiteWeb("");

    setNature("");
    setRegion("");
    setProvince("");
    setCommune("");
    setServicesOdd({});

    setOddOptions([]);
    setDemande({});
  };

  const handleCheckbox = (e) => {
    const { value, checked } = e.target;

    if (checked) setOddOptions((pre) => [...pre, value]);
    else setOddOptions((pre) => pre.filter((x) => x !== value));
  };

  const handleServicesOddChange = (updatedServicesOdd) =>
    setServicesOdd(updatedServicesOdd);

  const isStepOneValid = () => {
    const emailRegex = /\S+@\S+\.\S+/;
    return (
      prenom &&
      nom &&
      sexe &&
      email &&
      emailRegex.test(email) &&
      emailOrganisation &&
      emailRegex.test(emailOrganisation) &&
      telephoneFix &&
      nomOrganisme &&
      role &&
      assistance.length > 0
    );
  };

  const isStepTwoValid = () => {
    // Check if all required fields are selected
    const isNatureValid = !!nature;
    const isSecteurValid = secteur.length > 0;
    const isServiceValid = service.length > 0; // Ensuring at least one service is selected
    const isRegionValid = !!region; // Ensuring Region is selected
    const isProvinceValid = !!province; // Ensuring Province is selected
    const isCommuneValid = !!commune; // Ensuring Commune is selecte

    return (
      isNatureValid &&
      isSecteurValid &&
      isServiceValid &&
      isRegionValid &&
      isProvinceValid &&
      isCommuneValid
    );
  };

  return (
    <Box
      className="contact-page-inner bg-gray mx-auto justify-content-center align-items-center "
      ref={stepperRef}
      sx={{ width: "90%", mb: 50 }}
    >
      <Stepper
        alternativeLabel
        className="px-5"
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              className="text-uppercase"
              StepIconComponent={ColorlibStepIcon}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 2 ? (
        <Container maxWidth="lg">
          <div
            style={{
              textAlign: "center",
              backgroundColor: "#fff",
              padding: "30px",
            }}
          >
            <div className="alert alert-success">
              Demande envoyée avec succès !
            </div>

            <img
              src="/assets/illustration/24 - Successful startup.png"
              alt="Success Illustration"
              style={{ width: "300px", marginBottom: "20px" }}
            />
            <h1
              style={{
                fontSize: "2rem",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              Thank you!
            </h1>
            <p style={{ fontSize: "1.2rem", marginBottom: "20px" }}>
              Your submission is received and we will contact you soon.
            </p>
            <div className="d-flex justify-content-center">
              <Link
                className="btn-left-icon btn btn-border-gray mt-0 me-3"
                onClick={handleReset}
              >
                <FaArrowLeft /> Revenir au début
              </Link>
              <Link to={"/"} className="btn btn-base">
                Revenir à l'accueil
              </Link>
            </div>

            <br />
          </div>
          {/* <Grid container spacing={2}>
            <Grid xs={12}>
              <Box sx={{ m: 2, mt: 5 }}>
                <div className="card">
                  <div className="card-body">
                    <h6 className="d-flex">
                      <FaInfoCircle
                        style={{ alignSelf: "center", marginRight: "1%" }}
                      />{" "}
                      Demande envoyée avec succès !
                    </h6>
                    <p className="text-start">
                      Votre demande a été envoyée avec succès. Vous recevrez une
                      réponse dans les plus brefs délais.
                    </p>
                  </div>
                </div>
              </Box>
            </Grid>

            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Box sx={{ mx: 2, ml: 3, mt: 6 }}>
                <button
                  className="btn-left-icon btn-border-gray mt-0 me-3"
                  onClick={handleReset}
                >
                  Revenir au début <FaArrowLeft />
                </button>
              </Box>
            </Grid>
          </Grid> */}
        </Container>
      ) : (
        <Container maxWidth="lg">
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid xs={12}>
              <Box sx={{ m: 2 }}>
                <div>
                  {/* Display the error alert if there's an error message */}
                  {errorMessage && (
                    <div className="alert alert-danger mt-3" role="alert">
                      {errorMessage}
                    </div>
                  )}

                  {/* Rest of your component UI goes here */}
                </div>
              </Box>
            </Grid>
            {activeStep === 0 ? (
              <Grid container spacing={2}>
                <Grid xs={12}>
                  <Box sx={{ m: 2 }}>
                    <div>
                      <h5 className="title">Informations générales :</h5>
                      <aside class="MuiCallout-root MuiCallout-info">
                        <FaInfoCircle
                          style={{ alignSelf: "center", marginRight: "1%" }}
                        />
                        <div class="MuiCallout-content">
                          <p>
                            Remplissez tous les champs pour passer à l'étape
                            suivante
                          </p>
                        </div>
                      </aside>
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        placeholder="Prénom"
                        value={prenom}
                        onChange={(e) => setPrenom(e.target.value)}
                      />
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        placeholder="Nom"
                        value={nom}
                        onChange={(e) => setNom(e.target.value)}
                      />
                    </div>
                  </Box>
                </Grid>
                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="">
                      <Select
                        placeholder="Sélectionner le sexe"
                        options={[
                          { value: "Homme", label: "Homme" },
                          { value: "Femme", label: "Femme" },
                        ]}
                        value={sexe ? { value: sexe, label: sexe } : null}
                        onChange={(selectedOption) =>
                          setSexe(selectedOption ? selectedOption.value : "")
                        }
                        isClearable
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            padding: "0.8%",
                            borderRadius: "10px",
                          }),
                        }}
                      />
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="email"
                        placeholder="Adresse Email Ex : ( jhon@gmail.com )"
                        value={email}
                        required
                        onChange={(e) => setEmail(e.target.value)}
                      />

                      {/* Error message for invalid email */}
                      {email && !/\S+@\S+\.\S+/.test(email) && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          Please enter a valid email address !
                        </p>
                      )}
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        placeholder="Nom de votre organisme"
                        value={nomOrganisme}
                        onChange={(e) => setNomOrganisme(e.target.value)}
                      />
                    </div>
                  </Box>
                </Grid>
                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        placeholder="Quel est votre rôle professionnel au sein de l'organisme ?"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                      />
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="email"
                        placeholder="Adresse e-mail de l'organisme "
                        value={emailOrganisation}
                        required
                        onChange={(e) => setEmailOrganisation(e.target.value)}
                      />

                      {/* Error message for invalid email */}
                      {emailOrganisation && !/\S+@\S+\.\S+/.test(emailOrganisation) && (
                        <p style={{ color: "red", fontSize: "12px" }}>
                          Please enter a valid email address !
                        </p>
                      )}
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        placeholder="N° de Téléphone Fixe "
                        value={telephoneFix}
                        required
                        onChange={(e) => setTelephoneFix(e.target.value)}
                      />
                    </div>
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <Select
                      className=""
                      placeholder="Sélectionner vos types d'assistance"
                      value={assistanceOptions.filter((option) =>
                        assistance.includes(option.value)
                      )}
                      isMulti
                      isClearable={true}
                      closeMenuOnSelect={false}
                      options={assistanceOptions}
                      onChange={(selectedOptions) =>
                        setAssistance(
                          selectedOptions
                            ? selectedOptions.map((option) => option.value)
                            : []
                        )
                      }
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          padding: "0.8%",
                          borderRadius: "10px",
                        }),
                      }}
                    />
                  </Box>
                </Grid>

                <Grid xs={6}>
                  <Box sx={{ m: 2 }}>
                    <div className="single-input-inner style-border">
                      <input
                        type="text"
                        placeholder="Site Web (Si disponilbe)"
                        value={siteWeb}
                        onChange={(e) => setSiteWeb(e.target.value)}
                      />
                    </div>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={2}>
                <Grid xs={12}>
                  <Box sx={{ m: 2 }}>
                    <div>
                      <h5 className="title">
                        Informations à propos de l'organisation
                      </h5>
                      <aside class="MuiCallout-root MuiCallout-info">
                        <FaInfoCircle
                          style={{ alignSelf: "center", marginRight: "1%" }}
                        />
                        <div class="MuiCallout-content">
                          <p>
                            Remplissez tous les champs pour passer à l'étape
                            suivante
                          </p>
                        </div>
                      </aside>
                    </div>
                  </Box>
                </Grid>

                <Grid xs={4}>
                  <Box sx={{ m: 2 }}>
                    <p>
                      Nature <span className="text-danger">*</span>
                    </p>
                    <Select
                      placeholder="Nature"
                      isClearable={true}
                      options={natureOptions}
                      value={natureOptions.find(
                        (option) => option.value === nature
                      )}
                      onChange={(e) => setNature(e ? e.value : null)}
                    />
                  </Box>
                </Grid>
                <Grid xs={4}>
                  <Box sx={{ m: 2 }}>
                    <p>
                      Secteurs <span className="text-danger">*</span>
                    </p>
                    <Select
                      placeholder="Secteurs"
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      isMulti
                      options={secteurOptions}
                      onChange={setSecteur}
                      value={secteur}
                    />
                  </Box>
                </Grid>
                <Grid xs={4}>
                  <Box sx={{ m: 2 }}>
                    <p>
                      Services <span className="text-danger">*</span>
                    </p>
                    <Select
                      placeholder="Services"
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      isMulti
                      options={servicesOptions}
                      onChange={setService}
                      value={service}
                    />
                  </Box>
                </Grid>

                <Grid xs={4}>
                  <Box sx={{ m: 2 }}>
                    <p>
                      Région <span className="text-danger">*</span>
                    </p>
                    <Select
                      placeholder="Région"
                      isClearable={true}
                      options={regionOptions}
                      onChange={(e) => setRegion(e ? e.value : null)}
                      value={regionOptions.find(
                        (option) => option.value === region
                      )}
                    />
                  </Box>
                </Grid>
                <Grid xs={4}>
                  <Box sx={{ m: 2 }}>
                    <p>
                      Province <span className="text-danger">*</span>
                    </p>
                    <Select
                      placeholder="Province"
                      isClearable={true}
                      options={provinceOptions}
                      onChange={(e) => setProvince(e ? e.value : null)}
                      value={provinceOptions.find(
                        (option) => option.value === province
                      )}
                    />
                  </Box>
                </Grid>
                <Grid xs={4}>
                  <Box sx={{ m: 2 }}>
                    <p>
                      Commune <span className="text-danger">*</span>
                    </p>
                    <Select
                      placeholder="Commune"
                      isClearable={true}
                      options={communeOptions}
                      onChange={(e) => setCommune(e ? e.value : null)}
                      value={communeOptions.find(
                        (option) => option.value === commune
                      )}
                    />
                  </Box>
                </Grid>
                <Grid xs={12}>
                  <Box sx={{ m: 2 }}>
                    <h5 className="title">(ODD/SDGs) Couverts</h5>
                    <p class="content mb-0">
                      Veuillez sélectionner les Objectifs de Développement
                      Durable (ODD) qui correspondent aux actions de votre
                      organisation. Ces objectifs sont essentiels pour
                      contribuer à un avenir durable. Choisissez les ODD qui
                      reflètent vos priorités et engagements.
                    </p>
                  </Box>
                </Grid>
                <Box className="checkbox-odd" sx={{ display: "flex" }}>
                  <ul>
                    {ongData.services.map((x, index) => (
                      <li key={index}>
                        <input
                          type="checkbox"
                          value={x.label}
                          id={"checkOdd-" + index}
                          onChange={handleCheckbox}
                          checked={oddOptions.includes(x.label)}
                        />
                        <label htmlFor={"checkOdd-" + index}>
                          <img src={x.img} alt={x.label} />
                        </label>
                      </li>
                    ))}
                  </ul>
                </Box>
                {oddOptions.length > 0 && (
                  <Grid xs={12}>
                    <Box sx={{ m: 2 }}>
                      <h5 className="title">Services :</h5>
                      <AccordionOdd
                        oddOptions={oddOptions}
                        servicesOdd={servicesOdd}
                        handleServicesOddChange={handleServicesOddChange}
                      />
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}

            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Box sx={{ mx: 2, ml: 3, mt: 6 }}>
                <button
                  className="btn-left-icon btn-border-gray mt-0 me-3"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  sx={{ mr: 1 }}
                >
                  <FaMinusCircle /> Précédent
                </button>
              </Box>

              <Box sx={{ mx: 2, mr: 3, mt: 6 }}>
                <button
                  className="btn-left-icon btn-black"
                  onClick={handleNext}
                  disabled={
                    (activeStep === 0 && !isStepOneValid()) ||
                    (activeStep === 1 && !isStepTwoValid())
                  }
                >
                  {activeStep === steps.length - 1 ? "Terminer" : "Continuer"}{" "}
                  <FaArrowRight />
                </button>
              </Box>
            </Grid>
          </Box>
        </Container>
      )}
    </Box>
  );
};

export default MemberInscription;
